import { render, staticRenderFns } from "./CellRendererAge.vue?vue&type=template&id=caeac362"
import script from "./CellRendererAge.vue?vue&type=script&lang=js"
export * from "./CellRendererAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports